import Arrow from './Arrow';
import ArrowDiagonal from './ArrowDiagonal';
import Caret from './Caret';
import Chevron from './Chevron';
export const AlignedIcons = {
    Arrow,
    ArrowDiagonal,
    Caret,
    Chevron,
};
export default AlignedIcons;
